import { Modal } from '@quintoandar-tokko/jopijs';
import TableContainer from './TableContainer';
import styles from './performanceModals.module.scss';

export default function BaseModal({
  title,
  handleClose,
  children,
  headerId,
  className,
  ...rest
}) {
  const classNames = `${styles.modal} ${className ?? ''}`;

  return (
    <Modal
      modalBG
      blockScroll
      fixedCloseBtn
      closeModal={handleClose}
      className={classNames}
      {...rest}
    >
      <Modal.Header
        variant={['start', 'sm']}
        text={title}
        closeIcon={handleClose}
        className={styles.baseModalHeader}
        id={headerId}
      />
      <Modal.Body className={styles.modalBody}>{children}</Modal.Body>
    </Modal>
  );
}

BaseModal.TableContainer = TableContainer;
